import React from 'react';
import dayjs from 'dayjs';
import { DeviationsWithAuthor, DeviationTypes } from '../../types/orderTypes';
import './Deviation.scss';

type DeviationHistoryProps = {
  deviations: DeviationsWithAuthor[];
  type: DeviationTypes;
};

export function DeviationHistory({
  deviations,
  type,
}: DeviationHistoryProps): JSX.Element {
  if (deviations && !deviations.length) return <div />;

  const showDeviationsTable = () => {
    return deviations.map((deviation, index) => (
      <tr key={`${index}-${Math.random()}`}>
        <td>{deviation.authorName}</td>
        <td>{deviation.deviationMessage}</td>
        <td>{deviation.deviationStatus}</td>
        <td>{dayjs(deviation.timeOfDeviation).format('DD.MM HH:mm')}</td>
      </tr>
    ));
  };

  return (
    <div className="deviation-report-box">
      <div className="title-header"> {type} DEVIATION HISTORY </div>

      <table className="deviation-history-window-table">
        <thead>
          <tr>
            <th>AUTHOR</th>
            <th>MESSAGE</th>
            <th>STATUS</th>
            <th data-sortmethod="number"> TIME</th>
          </tr>
        </thead>
        <tbody>{showDeviationsTable()}</tbody>
      </table>
    </div>
  );
}
